import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Sidebar from "../../common/Sidebar";
import AddTattoo from "./AddTattoos";
import EditTattoo from "./EditTattoo";
import { changeLimit, changePage, deleteTattooThunk, fetchTattoosThunk, sortTattoosThunk, updateTattoosPositionThunk } from "../../apps/tatoosSlice";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import ViewTattoo from "./ViewTattoo";


const Tattoos = () => {
  const dispatch = useDispatch();
  const { tattoos, total, page, limit, pageCount } = useSelector((store) => store?.tattoos);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedTattoo, setSelectedTattoo] = useState(null);
  const [shuffledData, setShuffledData] = useState([]);
  const [isReordered, setIsReordered] = useState(false);
  const [isCheckedItems, setIsCheckedItems] = useState([]);
  const [isUnCheckedItems, setIsUnCheckedItems] = useState([]);
  const [isSortButtonVisible, setIsSortButtonVisible] = useState();

  useEffect(() => {
    dispatch(changeLimit(10))
    dispatch(fetchTattoosThunk({ params: { limit: 10, page: 1 } }));
  }, [showEditModal, showAddModal]);

  useEffect(() => {
    if (tattoos) {
      setIsCheckedItems(
        tattoos
          .filter(tattoo => tattoo?.isSorted)
          .map(tattoo => tattoo?._id)
      );
      setShuffledData([...tattoos]);
    }
  }, [tattoos]);

  const shouldCancelStart = (e) => {
    const tagName = e.target.tagName.toLowerCase();
    return ["button", "input", "textarea", "select", "i"].includes(tagName);
  };

  const handleView = (tattoo) => {
    setSelectedTattoo(tattoo);
    setShowViewModal(true);
  };

  const handleEdit = (tattoo) => {
    setSelectedTattoo(tattoo);
    setShowEditModal(true);
  };

  // limit handler
  const limitHandler = async (e) => {
    await dispatch(changeLimit(e.target.value))
    await dispatch(fetchTattoosThunk({ params: { limit: e.target.value, page: 1 } }));
    // await dispatch(changePage(1))
  }

  const handleCheckedItems = (e, id) => {
     setIsSortButtonVisible(true)
     if (e.target.checked) {
       setIsUnCheckedItems((prevItems) => prevItems.filter(Id => Id !== id));
       return setIsCheckedItems((prevItems) => [...prevItems, id]);
     }
     else {
       // Remove item ID from checkedItems state if unchecked
       setIsUnCheckedItems((prevItems) => [...prevItems, id])
       setIsCheckedItems((prevItems) => prevItems.filter(Id => Id !== id));
     }
   }
   const sortTattoos = async () => {
    if( isCheckedItems.length !== 0){
 
       await dispatch(sortTattoosThunk({ id:isCheckedItems,isSorted:true }))
       // setIsCheckedItems([])
     }
     if( isUnCheckedItems.length !== 0){
 
       await dispatch(sortTattoosThunk({ id:isUnCheckedItems,isSorted:false  }))
     }
     dispatch(fetchTattoosThunk({ params: { limit, page } }));
     setIsSortButtonVisible(false)
   }

  const SortableItem = SortableElement(({ item }) => (
    <tr key={item._id}>
      <td>{item?._id}</td>
      <td>{item?.height}</td>
      <td>{item?.width}</td>
      <td>{item?.position}</td>
      <td><input type="checkbox" checked={isCheckedItems.includes(item._id)} onChange={(e) => handleCheckedItems(e, item._id)} /></td>
      <td>
        <img src={item?.imageUrl} alt="Thumbnail" width={120} height={150} />
      </td>
      <td>
        <img src={item?.thumb} alt="Thumbnail" width={120} height={150} />
      </td>
      <td>
        <button className="btn action_btn" onClick={() => handleView(item)}>
          <i className="fa fa-eye"></i>
        </button>
        <button className="btn action_btn" onClick={() => handleEdit(item)}>
          <i className="fa fa-pencil"></i>
        </button>
        <button className="btn action_btn">
          <i className="fa fa-trash" onClick={() => deleteTattoo(item._id)}></i>
        </button>
      </td>
    </tr>
  ));

  const SortableList = SortableContainer(({ items }) => (
    <tbody>
      {items?.map((item, index) => (
        <SortableItem key={item._id} index={index} item={item} />
      ))}
    </tbody>
  ));

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const updatedData = arrayMoveImmutable(shuffledData, oldIndex, newIndex);

      // Assign new order based on the updated position
      const reorderedData = updatedData.map((item, index) => ({
        ...item,
        order: index + 1, // Assigning correct order starting from 1
      }));

      setShuffledData(reorderedData);
      setIsReordered(true);

    }
  };

  const handleSavePosition = async () => {
    const reorderedIds = shuffledData.map((item) => item._id);

    // Dispatch the update order action
    await dispatch(updateTattoosPositionThunk({ position: reorderedIds }));

    // Fetch the updated tattoos to refresh UI
    dispatch(fetchTattoosThunk({ params: { limit, page } }));

    setIsReordered(false);
    setIsCheckedItems([])

    toast.success("Order updated successfully!");
  };

  const handlePageClick = async (data) => {
    await dispatch(changePage(data.selected + 1));
    await dispatch(fetchTattoosThunk({ params: { limit, page: data.selected + 1 } }));
  };

  const deleteTattoo = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      await dispatch(deleteTattooThunk({ id }));
      dispatch(fetchTattoosThunk({ params: { limit, page } }));
      Swal.fire("Deleted!", "The tattoo has been deleted.", "success");
    }
  };


  const handleSavedTatto = async () => {
    setShowAddModal(false)
    await dispatch(fetchTattoosThunk({ params: { limit, page } }));
  };

  return (
    <>
      <Sidebar />
      <div className="card">
        <div className="card-header bg-white card-header-wrapper">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-0">Tattoos</h3>
            <Button className="btn add_btn" onClick={() => setShowAddModal(true)}>Add</Button>
          </div>
        </div>

        <div className="table-responsive">
          <Table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Height</th>
                <th>Width</th>
                <th>Position</th>
                <th>Sort</th>
                <th>image</th>
                <th>Thumbnail</th>
                <th>Action</th>
              </tr>
            </thead>
            <SortableList items={shuffledData} onSortEnd={onSortEnd} axis="y" shouldCancelStart={shouldCancelStart} />
          </Table>
        </div>



        <div className="d-flex justify-content-end m-3">
          {isSortButtonVisible && (
            <Button onClick={sortTattoos} className="me-2">Sort</Button>
          )
          }
          {isReordered && (
            <Button variant="success" onClick={handleSavePosition}>Save Position</Button>
          )}
        </div>

        {total > 0 && (
          <div className="d-flex justify-content-between align-items-center px-3 mb-2">
            <div>
              <select className="form-select" onChange={(e) => limitHandler(e)}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div>
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"..."}
                pageCount={pageCount === 1 ? 1 : pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(data) => handlePageClick(data)}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"pagination_prev"}
                previousLinkClassName={"page-link"}
                nextClassName={"pagination_next"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={page - 1}
              />
            </div>
          </div>
        )}
      </div>

      {/* Modals */}

      <Modal show={showAddModal} size="xl">
        <Modal.Header closeButton onHide={() => setShowAddModal(false)}></Modal.Header>
        <Modal.Body><AddTattoo onClose={handleSavedTatto} /></Modal.Body>
      </Modal>

      <Modal show={showViewModal} size="lg" centered className="edit-modal">
        <Modal.Header closeButton onHide={() => setShowViewModal(false)} ><Modal.Title>Edit Tattoo</Modal.Title></Modal.Header>
        <Modal.Body>{selectedTattoo ? <ViewTattoo tattooItem={selectedTattoo} onClose={() => setShowViewModal(false)} /> : <p>No tattoo selected.</p>}</Modal.Body>
      </Modal>

      <Modal show={showEditModal} size="lg" centered className="edit-modal">
        <Modal.Header closeButton onHide={() => setShowEditModal(false)} ><Modal.Title>Edit Tattoo</Modal.Title></Modal.Header>
        <Modal.Body>{selectedTattoo ? <EditTattoo tattooItem={selectedTattoo} onClose={() => setShowEditModal(false)} /> : <p>No tattoo selected.</p>}</Modal.Body>
      </Modal>
    </>
  );
};

export default Tattoos;
